const mainColor = "#3b3b3d"; //"#7aadff"
const backgroundColor = "#f2f2f0"

const secondaryColor = "white";

const successColor = "green";
const errorColor = "red";


export const Colors = {
    mainColor,
    backgroundColor,
    secondaryColor,
    successColor, 
    errorColor,
}